import { combineReducers } from 'redux';
import appReducer from './app.reducer';
import alertReducer from './alert.reducer';

export default combineReducers({
  app: appReducer,
  alert: alertReducer,
});